import { render, staticRenderFns } from "./TaxAdd.vue?vue&type=template&id=2df964f9"
import script from "./TaxAdd.vue?vue&type=script&lang=js"
export * from "./TaxAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports